import React, { useContext } from 'react'
import CreateDtcMappingsCheckbox from '../CreateDtcMappingsCheckbox'
import { ConnectorPinsContext } from '../../context/context'

const SearchOldLevelsCheckbox = () => {
  const [state, dispatch] = useContext(ConnectorPinsContext)

  const onChange = (checked) => {
    dispatch({ type: 'search_old_levels', data: checked })
  }

  return (
    <CreateDtcMappingsCheckbox
      title={'Search old levels'}
      field={'search_old_levels'}
      checked={state?.search_old_levels}
      onChange={onChange}
    />
  )
}

export default SearchOldLevelsCheckbox
